<template>
  <v-container>
    <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>
    <div>
        <v-row justify="center">
            <v-col
                cols="6"
                >
                <div class="text-h4" style="margin-top: 30px;">
                    DX-Sign申込み
                </div>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col
                cols="6"
                >
                <p class="pl-5 py-5">登録するメールアドレスをご入力ください</p>
            </v-col>
        </v-row>

    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
    >
      <form @submit.prevent="submit">
        <v-row justify="center">
            <v-col
            
              cols="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="email"
                  rules="required|email"
                >
                 <v-text-field
                    v-model="email"
                    :error-messages="errors"
                    label="メールアドレス"
                    required
                    outlined
                    clearable
                    background-color="white"
                  ></v-text-field>
                </validation-provider>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col
                cols="6"
                >
                <v-btn
                  class="mr-4 white--text"
                  color="red"
                  v-on:click="submit"
                  :disabled="invalid"
                >
                  仮登録
                </v-btn>
            </v-col>
        </v-row>
      </form>
    </validation-observer>
  </div>
  </v-container>
</template>

<script>
  import axios from 'axios';
  import { required, email } from 'vee-validate/dist/rules';
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';

  extend('required', {
    ...required,
    message: '入力必須項目です',
  });

  extend('email', {
    ...email,
    message: '正しいメールアドレスを入力してください',
  });

  export default {
          components: {
            ValidationProvider,
            ValidationObserver,
          },
          data: function () {
            return {
                email: null,
                // メッセージ
                message: null,
                success: false,
            };
        },
        methods: {
          submit: function (event) {
            // バリデーション実行
            this.$refs.observer.validate().then((result) => {
              if(result) {
                var params = {
                  'email': this.email,
                };
                axios.post('/documents/apply', params)
                .then(res => {
                  this.success = res.data.success;
                  this.message = res.data.message;
                  if (this.success) {
                    window.location = "/documents/apply_complete";
                  }
                }).catch(res => {
                  // console.log(res);
                  this.success = false;
                  this.message = "処理に失敗しました";
                }).finally(() => {
                });
              }
            });
          }
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
  };
</script>